import React from 'react';

export const ParticleBackground: React.FC = () => {
  return (
    <div className="fixed inset-0 pointer-events-none -z-20 overflow-hidden select-none">
      {/* Hardware-Accelerated Ambient Glowing Halos (Zero CPU/GPU overhead) */}
      <div 
        className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full opacity-20 pointer-events-none"
        style={{
          background: 'radial-gradient(circle, #00F0FF 0%, rgba(0, 240, 255, 0.05) 50%, transparent 70%)',
          transform: 'translateZ(0)',
          willChange: 'transform'
        }}
      />
      <div 
        className="absolute -bottom-40 -right-40 w-[650px] h-[650px] rounded-full opacity-20 pointer-events-none"
        style={{
          background: 'radial-gradient(circle, #7000FF 0%, rgba(112, 0, 255, 0.05) 50%, transparent 70%)',
          transform: 'translateZ(0)',
          willChange: 'transform'
        }}
      />
      <div 
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full opacity-10 pointer-events-none"
        style={{
          background: 'radial-gradient(circle, #0051FF 0%, transparent 60%)',
          transform: 'translateZ(0)'
        }}
      />

      {/* Cyber Grid Background Lines (Crisp & Zero Lag) */}
      <div 
        className="absolute inset-0 opacity-[0.03] pointer-events-none"
        style={{
          backgroundImage: `
            linear-gradient(to right, rgba(255,255,255,0.15) 1px, transparent 1px),
            linear-gradient(to bottom, rgba(255,255,255,0.15) 1px, transparent 1px)
          `,
          backgroundSize: '40px 40px',
          maskImage: 'radial-gradient(ellipse at center, black 40%, transparent 80%)',
          WebkitMaskImage: 'radial-gradient(ellipse at center, black 40%, transparent 80%)'
        }}
      />
    </div>
  );
};
